<div class="row border-bottom pl-1 pr-1 ml-1 mr-1">
	<ng-container *ngIf="!sending">
		<button class="btn btn-success" (click)="exportXls();"><i class="fa fa-file-excel-o"></i></button>
		&nbsp;&nbsp;
		<button class="btn btn-danger" (click)="exportPdf();"><i class="fa fa-file-pdf-o"></i></button>
	</ng-container>
	<ng-container *ngIf="sending">
		<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</ng-container>

	<div class="table" #print_table>
		<h4>Results: {{ data.length }}</h4>
		<table class="table table-sm">
			<thead class="thead-dark sticky-header">
			<tr>
				<th class="sticky-header noprint"></th>
				<th class="sticky-header">Customer#</th>
				<th class="sticky-header">Name</th>
				<th class="sticky-header">Total</th>
				<th class="sticky-header">Transaction info</th>
				<th class="sticky-header noprint">View transactions</th>
			</tr>
			</thead>
			<tbody>
			<ng-container *ngFor="let d of data">
				<tr>
					<td class="noprint">
						<a mat-button (click)="$event.preventDefault();autoAllocateMatching(d)" *ngIf="allowed_allocate">
							<mat-icon>published_with_changes</mat-icon>
						</a>
					</td>
					<td><a [routerLink]="'/customers/view/' + d.debtorno">{{ d.debtorno }}</a></td>
					<td>{{ d.name }}</td>
					<td>{{ d.total | currency }}</td>
					<td class="transaction-info">
						<ng-container *ngIf="d.doc_count != null || d.match_count != null || d.oldest_due">
							<span *ngIf="d.doc_count != null">Docs: {{ d.doc_count }}</span>
							<span *ngIf="d.match_count != null">{{ d.doc_count != null ? ' · ' : '' }}Matches: {{ d.match_count }}</span>
							<span *ngIf="d.oldest_due">{{ (d.doc_count != null || d.match_count != null) ? ' · ' : '' }}Oldest: {{ d.oldest_due }}</span>
						</ng-container>
						<ng-container *ngIf="d.doc_count == null && d.match_count == null && !d.oldest_due">—</ng-container>
					</td>
					<td class="noprint">
						<button mat-stroked-button color="primary" (click)="toggleTransactions(d)" [disabled]="loadingTransactions">
							<mat-icon *ngIf="expandedDebtorno === d.debtorno">expand_less</mat-icon>
							<mat-icon *ngIf="expandedDebtorno !== d.debtorno">list</mat-icon>
							{{ expandedDebtorno === d.debtorno ? 'Close' : 'View' }}
						</button>
					</td>
				</tr>
				<tr *ngIf="expandedDebtorno === d.debtorno && customer_data">
					<td colspan="6" class="p-0">
						<div class="border-top bg-light p-2">
							<button mat-stroked-button class="mb-2" (click)="closeTransactions()">
								<mat-icon>expand_more</mat-icon> Close transactions
							</button>
							<app-customer-trans [customerdata]="customer_data" [pos]="false"></app-customer-trans>
						</div>
					</td>
				</tr>
			</ng-container>
			</tbody>
		</table>
	</div>
</div>
